module.exports = __webpack_public_path__ + "static/mapping-c2d09e58a5d2967c382edd5a7333945d.mp4";